export default __webpack_public_path__ + "static/media/02-min.9b1444ef.jpg";